import { useEffect, useState } from "react";
import { MdEmail, MdLanguage, MdLocationPin, MdPhone, MdTravelExplore } from "react-icons/md";
import { getInlineLoader } from "../Helpers";
import { company, contactCards } from "../siteContent";

export default function ContactUsContent(props) {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection" style={{ paddingBottom: "70px", paddingTop: "55px" }}>
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-6">
            <div className="tff-section-kicker">Contact Us</div>
            <h2 className="tff-section-title">
              Start planning your Zanzibar and Tanzania experience.
              <span className="tff-section-underline"></span>
            </h2>
            <p className="font-light tff-section-lead">
              Share your preferred travel dates, group size, accommodation style, and the experiences you want most. We
              will shape a smooth itinerary around your needs.
            </p>

            <div className="card tff-contact-brand-card">
              <div className="card-body p-4 p-lg-5">
                <img src={company.logo} alt={company.shortName} className="tff-contact-logo rounded-pill" />
                <h4 className="font-bold text-primary mt-4">{company.name}</h4>
                <p className="font-light mb-0">{company.tagline}</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card h-100">
              <div className="card-body p-4 p-lg-5">
                <div className="tff-contact-detail">
                  <MdLocationPin size={24} className="text-secondary" />
                  <div>
                    <p className="font-semi-bold mb-1">Office Address</p>
                    <p className="mNoMargin">{company.location}</p>
                  </div>
                </div>

                <div className="tff-contact-detail">
                  <MdEmail size={24} className="text-secondary" />
                  <div>
                    <p className="font-semi-bold mb-1">Email</p>
                    <p className="mNoMargin">{company.email}</p>
                  </div>
                </div>

                <div className="tff-contact-detail">
                  <MdPhone size={24} className="text-secondary" />
                  <div>
                    <p className="font-semi-bold mb-1">Phone</p>
                    <p className="mNoMargin">{company.phone}</p>
                  </div>
                </div>

                

                <div className="tff-contact-cta">
                  <MdTravelExplore size={24} className="text-primary mb-2" />
                  <p className="font-semi-bold mb-2">Best for itinerary requests</p>
                  <p className="font-light mNoMargin">
                    Send your travel brief with preferred destinations, hotel level, transport needs, and whether you
                    want Zanzibar only or a combined mainland safari extension.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4 mt-3">
          {contactCards.map((item) => (
            <div key={item.title} className="col-md-4">
              <div className="card h-100">
                <div className="card-body p-4">
                  <h5 className="font-semi-bold text-primary mb-3">{item.title}</h5>
                  <p className="font-light mNoMargin">{item.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
